import { Button, ButtonSubmit, Modal, SelectField, TextAreaField } from 'components';
import { FormikProvider, useFormik } from 'formik';
import { Form } from 'formik-antd';
import { yup } from 'libs';
import { uniqBy } from 'lodash';
import { workerSelector } from 'pages/Home/Bo/selectors';
import { FC } from 'react';
import { useSelector } from 'react-redux';
import { workerService } from 'services';
import SectionStyled from './styles';

interface Props {
  visible?: boolean;
  onCancel?: () => void;
  title?: string;
}

const ContactWorker: FC<Props> = ({
  visible = false,
  title = '工事担当者へ連絡',
  onCancel = () => null,
}) => {
  const { unpropertyListShop } = useSelector(workerSelector);

  const sites = unpropertyListShop.sites;

  const uniqSites = uniqBy(
    sites.map((s) => {
      const splitBuildingCode = s.building_code.split('-');
      splitBuildingCode.pop();

      return {
        ...s,
        building_code: splitBuildingCode.join('-'),
      };
    }),
    'building_code'
  );

  const formik = useFormik({
    initialValues,
    validationSchema,
    async onSubmit(values) {
      try {
        await workerService.postInformation({
          building_id: values.building_id,
          content: values.content,
          push_flag: 0,
        });
        formik.resetForm();
        onCancel();
      } catch (error) {
        onCancel();
        console.error(error);
      }
    },
  });

  const onCancelButton = () => {
    onCancel();
    formik.resetForm();
  };

  return (
    <>
      <Modal title={title} visible={visible} footer={false} width={640}>
        <SectionStyled>
          <FormikProvider value={formik}>
            <Form layout="vertical" className="form">
              <div className="group-input">
                <div className="box-select">
                  <Form.Item
                    className="input-onsite"
                    label="現場名"
                    colon={false}
                    name="building_id"
                  >
                    <SelectField
                      data={
                        uniqSites &&
                        uniqSites.map((item) => ({
                          label: item.site_name,
                          value: item.building_id,
                        }))
                      }
                      name="building_id"
                      className="select-field"
                      placeholder="現場名を選択してください"
                    />
                  </Form.Item>
                </div>
                <Form.Item className="note-field" label="内容" name="content" colon={false}>
                  <TextAreaField
                    name="content"
                    className="text-area"
                    placeholder="連絡事項を入力してください"
                    autoSize={{ maxRows: 5 }}
                  />
                </Form.Item>
              </div>
              <div className="ant-modal-footer">
                <Button className="button-secondary" onClick={onCancelButton}>
                  キャンセル
                </Button>
                <ButtonSubmit disabled={!formik.isValid || !formik.dirty}>送信</ButtonSubmit>
              </div>
            </Form>
          </FormikProvider>
        </SectionStyled>
      </Modal>
    </>
  );
};

const initialValues = {
  building_id: '',
  content: '',
};

const validationSchema = yup.object().shape({
  building_id: yup.string().required('現場を選択してください。').label('現場'),
  content: yup
    .string()
    .max(1000, '入力可能文字数を超えています。')
    .required('内容を入力してください。')
    .label('内容'),
});

export default ContactWorker;
